import { render, staticRenderFns } from "./CollapseGroup.vue?vue&type=template&id=289391e1&scoped=true&"
import script from "./CollapseGroup.vue?vue&type=script&lang=ts&"
export * from "./CollapseGroup.vue?vue&type=script&lang=ts&"
import style0 from "./CollapseGroup.vue?vue&type=style&index=0&id=289391e1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289391e1",
  null
  
)

export default component.exports